import { useFormik } from "formik";
import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FileDisplay from "../../../utils/FileDisplay";
import { NuDate, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { handleKeyDown, ScreenClose } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
  vendorList=[],
  id,
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [createNew, setCreateNew] = useState({
    standard_id: "",
    vendor_id: "",
    on_board_date: "",
  });
  useEffect(() => {
    setCreateNew({
      standard_id: data?.standard_id,
      vendor_id: data?.vendor_id,
      on_board_date: data?.on_board_date,
    });
    setFilePathList(data?.attachments);
    setRemoveFilePathList(data?.attachments);
  }, [data]);

  function handleImageChange(e) {
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async(value, { resetForm }) => {
      if (data?.id) {
        let finalArr = removefilePathList.filter(
          (items) => !filePathList.includes(items)
        );
        value.files_to_remove = finalArr;
        let formdata = new FormData();
        formdata.append("vendorDetails", JSON.stringify(value));
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formdata.append("attachments", file);
          });
        } else {
          formdata.append("attachments", []);
        }
        await ScreenClose({link:"ConnectVendor/update",id:data.id})
        await editData({
          url: `/ConnectVendor/update/${data.id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile: true,
          setSelectedFile: setSelectedFile,
        });
      } else {
        value.standard_id = Number(id);
        let formdata = new FormData();
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formdata.append("attachments", file);
          });
        }
        formdata.append("vendorDetails", JSON.stringify(value));
        addData({
          url: `/ConnectVendor/add`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      }
    },
  });
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    if(data){
      ScreenClose({link:"ConnectVendor/update",id:data.id})
    }
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <FormikSelectTwo
                formik={formik}
                name="vendor_id"
                label="Vendor"
                width="w-full"
                placeholder="Select Vendor Type"
                Options={vendorList}
                isDisabled={data?true:false}
                zindex={12}
              />
              <NuDate
               name="on_board_date"
               label="OnBoard Date"
               width="w-full"
               formik={formik}
              />
              <NuUpload
                label="Documents Type - NDA, Contract"
                width="w-full"
                onChange={handleImageChange}
                multiple={true}
              />
              <div className=" w-full flex flex-wrap ">
                {data?.attachments &&
                  filePathList.map((i) => {
                    return (
                      <div className=" m-1 my-3">
                        <div className=" relative">
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-bold flex justify-center items-center  -top-2 right-2 z-10"
                            onClick={() => UpdateAttachmentList(i)}
                          >
                            -
                          </div>
                          <FileDisplay data={i} view={true} height={"45px"} width={"45px"} />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
